import React, { useContext, useState } from "react";
import styles from "./MainCard.module.scss";
import Button from "./Button";
import CreditValueEditorModal from "../modals/CreditValueEditorModal";
import NetworkService from "../../NetworkService";
import { refetchCompanyData, toasterFunction } from "../utils";
import { Message } from "rsuite";
import classNames from "classnames";
import { useGlobalContext } from "../../GlobalContext";


const MIN_CREDIT_VALUE = 5000;


function MainCard({ className }) {
  const { user: userState, companyData: companyDataState } = useGlobalContext();
  const [companyData, setCompanyData] = companyDataState;
  const [user] = userState;

  const [openCreditEditModal, setOpenCreditEditModal] = useState<boolean>(false);

  const requestCompanyCredit = async (credit: number) => {
    await NetworkService.requestCompanyCredit(credit);
    setOpenCreditEditModal(false);
    refetchCompanyData(setCompanyData);
    toasterFunction(
      <Message closable type="success">
        Mail with invoice successfully sent.
      </Message>
    );
  };


  if (!companyData || !user) {
    return (
      <div className={classNames(styles.noPadding, styles.gridHost, className)}>
        <div className={classNames(styles.mainCard, styles.loadingCard)} />
      </div>
    );
  }

  return (
    <div className={classNames(styles.noPadding, styles.gridHost, className)}>
      <CreditValueEditorModal
        btnLabel="Add credit"
        header="How much credit you want to add?"
        subHeader="Credit in RSD / Minimum 5000.00 RSD"
        initialLimitValue={MIN_CREDIT_VALUE}
        onSubmit={(credit) => requestCompanyCredit(credit)}
        open={!!openCreditEditModal}
        close={() => setOpenCreditEditModal(false)}
        minValue={MIN_CREDIT_VALUE}
      />
      <div className={styles.mainCard}>
        <InfoItem flex={1}>
          <div>
            <span className={styles.label}>Profile owner:</span>
            <span className={styles.companyName}>{companyData?.company?.name}</span>
          </div>
          <div className={styles.mainInfoText}>{user?.user?.name}</div>
        </InfoItem>
        <InfoItem flex={2}>
          <div className={styles.label}>ID:</div>
          <div className={styles.mainInfoText}>{user?.user?.id}</div>
        </InfoItem>

        <Button
          disabled={!companyData?.company?.active}
          onClick={() => setOpenCreditEditModal(true)}
          className={styles.addCreditButton}
          variant="green">
          Add Credit
        </Button>
      </div>
    </div>
  );
}

export default MainCard;

const InfoItem = ({ children, flex }) => {
  return (
    <div style={{ flex: flex }} className={styles.infoItem}>
      {children}
    </div>
  );
};
